module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._t("before"), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return _c('v-chip', {
      key: item.id,
      attrs: {
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.$emit('selected', item)
        }
      }
    }, [_vm._v("\n    " + _vm._s(item.title) + "\n    "), (_vm.withSpaceName) ? _c('span', [_vm._v("@" + _vm._s(item.space_name))]) : _vm._e()])
  }), _vm._v(" "), _vm._t("after")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09ae8238","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/ProductChips.vue
// module id = 1644
// module chunks = 0